export function handleLocalStorage(type, key, value) {
  if (type === "set") {
    localStorage.setItem(key, value);
  } else if (type === "get") {
    return localStorage.getItem(key);
  }
}



//////////////////
// WEBPACK FOOTER
// ./utils/index.js
// module id = null
// module chunks = 